module.exports = __webpack_public_path__ + "static/318214477_666023398527432_164412103811608131_n.jpg-1671186393188-9a4d8277951f8e6928f68dd8e8916633.webp";